const worksite = {
  "page": {
    "loading": "Loading the page...",
  },
  "panel": {
    "membersTitle": "Connected workers",
    "membersEmpty": "No workers are currently connected",
    "membersCount": "Total {{count}}",
    "refreshMembers": "Refresh worker locations",
    "unknownPosition": "Location unknown",
    "pollingDegraded": "Connection is delayed — showing the last snapshot",
  },
  "role": {
    "owner": "Owner",
    "inspector": "Inspector",
    "viewer": "Viewer",
  },
  "relative": {
    "justNow": "just now",
    "minutesAgo": "{{value}} min ago",
    "hoursAgo": "{{value}} hr ago",
    "daysAgo": "{{value}} days ago",
    "unknown": "-",
  },
  "member": {
    "role": "Role",
    "lastReported": "Last position report",
    "accuracy": "GPS accuracy",
    "violationState": "Violation status",
    "violationNone": "Clear",
    "closeCard": "Close detail card",
  },
  "violation": {
    "badge": "Violation",
    "toast": "{{name}} — entered restricted zone {{zone}}",
    "unknownZone": "restricted zone",
  },
  "marker": {
    "ariaLabel": "Worker {{label}} marker",
    "violationSpoken": "in restricted zone",
  },
  "layers3d": {
    "title": "Layers",
    "mesh": "Mesh",
    "loading": "Loading 3D layers...",
    "empty": "No 3D layers (Mesh·BIM·GIS) to display",
    "emptyModels": "No 3D layers (Mesh·BIM) to display",
    "loadFailed": "Failed to load",
    "count": "Total {{count}}",
  },
  "zones": {
    "manage": "Manage restricted zones",
    "count": "Total {{count}}",
    "empty": "No restricted zones registered",
    "draw": "Draw new restricted zone",
    "drawingHint":
      "Click the map to place vertices, then double-click to finish. Press ESC or right-click to cancel.",
    "drawCancel": "Cancel drawing",
    "rename": "Rename",
    "renameInput": "Name of {{name}}",
    "renameConfirm": "Save name of {{name}}",
    "renameCancel": "Cancel renaming {{name}}",
    "delete": "Delete",
    "rowMenu": "{{name}} menu",
    "active": "Active",
    "deleteConfirmTitle": "Delete restricted zone",
    "deleteConfirmMessage": "Delete zone '{{name}}'?",
    "deleteConfirmSub": "This cannot be undone.",
    "cancel": "Cancel",
  },
  "zoneDialog": {
    "createTitle": "New restricted zone name",
    "renameTitle": "Rename restricted zone",
    "nameLabel": "Zone name",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "tooFewPoints": "Place at least 3 vertices",
  },
  "error": {
    "presencePoll": "Failed to load connected workers — retrying automatically",
    "presenceLoad": "Failed to load connected workers",
    "projectNoLocation": "This site has no location to show on the map",
    "projectLoad": "Failed to load site information",
    "zonesLoad": "Failed to load restricted zones",
    "zoneCreate": "Failed to create the restricted zone",
    "zoneUpdate": "Failed to update the restricted zone",
    "zoneDelete": "Failed to delete the restricted zone",
    "noPermission": "You do not have permission",
  },
} as const;

export default worksite;
